export default __webpack_public_path__ + "static/media/flend.a2103ef8.svg";